<template>
  <div id="enterprise-agency-view-data">
    <enterprise-agency-form
      mode="view"
      :itemId="itemId"
    >
    </enterprise-agency-form>
  </div>
</template>

<script>

import EnterpriseAgencyForm from "./EnterpriseAgencyForm";

export default {
  components: {
    EnterpriseAgencyForm,
  },
  data() {
    return {
      itemId: this.$route.params.itemId
    }
  },
  created() {
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
</style>
